import React from 'react';
import { SocialLinks } from './SocialLinks';

/**
 * Slim footer shown on the customer & driver dashboards so authenticated users
 * can always reach the Terms and Privacy policies (mirrors the public footer).
 *
 * Legal pages open in a NEW TAB so the dashboard stays mounted — avoids any
 * back-button / re-mount weirdness and matches the convention for legal docs.
 */
export default function DashboardFooter() {
  return (
    <footer
      className="mt-12 py-6 border-t border-gray-100 bg-white"
      data-testid="dashboard-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
        <p className="font-medium text-gray-600">
          &copy; {new Date().getFullYear()} JustDeliver.ie
        </p>
        <nav className="flex items-center gap-5">
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#1B5E20] hover:underline"
            data-testid="dashboard-footer-terms"
          >
            Terms &amp; Conditions
          </a>
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#1B5E20] hover:underline"
            data-testid="dashboard-footer-privacy"
          >
            Privacy Policy
          </a>
        </nav>
        <SocialLinks label="" />
      </div>
    </footer>
  );
}
